/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Unlock16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M7.9.6c2.4 0 4.3 2 4.4 4.4 1 .2 1.7 1 1.7 2v5c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-1.9h7.2c0-1.9-1.6-3.4-3.4-3.4-.7 0-1.5.2-2.1.7-.2.2-.5.1-.7-.1-.1-.3-.1-.6.2-.8C5.9.9 6.9.6 7.9.6zM12 6H4c-.5 0-1 .5-1 1v5c0 .6.4 1 1 1h8c.5 0 1-.5 1-1V7c0-.6-.4-1-1-1zM9.5 9c.3 0 .5.2.5.5s-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5z"
        />
    </AccessibleSVG>
);

export default Unlock16;
